<template>
  <div
    class="bg-modal-bgr-overlay absolute inset-0 z-10 flex flex-col items-center justify-center overscroll-contain rounded-md"
  >
    <CircularLoader />
    <slot>
      <div v-if="text" class="drop-shadow-loader/60 mt-4 text-xl">
        {{ text }}
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
  defineOptions({
    name: "Overlay",
  });
  withDefaults(
    defineProps<{
      text?: string;
    }>(),
    {
      text: "",
    }
  );
</script>
